<template>
  <transition :name="getIsSplashOpen ? null : 'fade'" appear>
    <div class="splash-screen">
      <LanguageSelect :lang="lang" />

      <div
        class="slide-bg"
        :style="splashImages !== undefined ? `background-image: url(https://2020-uki.s3.eu-west-2.amazonaws.com/PA_Onboarding/images/gettyimages/${splashImages[2]});` : null"
      ></div>

      <!-- SPLASH IMAGES -->
      <kinesis-container class="splash-images-wrapper" :duration="2000">
        <kinesis-element :strength="10" class="v-center">
          <div class="splash-info">
            <img
              src="https://2020-uki.s3.eu-west-2.amazonaws.com/PA_Onboarding/logos/GettyImages_White.svg"
              class="splash-getty-logo"
            />

            <h1>{{ this.pageTitle[this.lang] }}</h1>
            <p>{{ this.splashIntroText }}</p>

            <button class="splash-button" @click="isSplashOpenAction()">
              {{ this.explore }}
            </button>
          </div>
        </kinesis-element>

        <kinesis-element
          :style="splashImages !== undefined ? `background-image: url(https://2020-uki.s3.eu-west-2.amazonaws.com/PA_Onboarding/images/gettyimages/${splashImages[0]});` : null"
          class="splash-image"
          :strength="-50"
          type="translate"
        ></kinesis-element>
        <kinesis-element
          :style="splashImages !== undefined ? `background-image: url(https://2020-uki.s3.eu-west-2.amazonaws.com/PA_Onboarding/images/gettyimages/${splashImages[1]});` : null"
          class="splash-image"
          :strength="-15"
          :type="parallexType"
        ></kinesis-element>
        <kinesis-element
          :style="splashImages !== undefined ? `background-image: url(https://2020-uki.s3.eu-west-2.amazonaws.com/PA_Onboarding/images/gettyimages/${splashImages[2]});` : null"
          class="splash-image"
          :strength="15"
          :type="parallexType"
        ></kinesis-element>
        <kinesis-element
          :style="splashImages !== undefined ? `background-image: url(https://2020-uki.s3.eu-west-2.amazonaws.com/PA_Onboarding/images/gettyimages/${splashImages[3]});` : null"
          class="splash-image"
          :strength="25"
          :type="parallexType"
        ></kinesis-element>
        <kinesis-element
          :style="splashImages !== undefined ? `background-image: url(https://2020-uki.s3.eu-west-2.amazonaws.com/PA_Onboarding/images/gettyimages/${splashImages[4]});` : null"
          class="splash-image"
          :strength="65"
          :type="parallexType"
        ></kinesis-element>
        <kinesis-element
          class="mouse-glow"
          :strength="-320"
          type="translate"
        ></kinesis-element>
      </kinesis-container>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LanguageSelect from "./LanguageSelect.vue";

let root = document.documentElement;

export default {
  components: { LanguageSelect },
  props: {
    splashImages: {
      type: Array,
      default: null,
    },
    lang: {
      type: String,
      default: null,
    },
    splashIntro: {
      type: Object,
      default: null,
    },
    pageTitle: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isLanguageSelectOpen: false,
      parallexType: "translate",
    };
  },
  computed: {
    ...mapGetters(["getIsSplashOpen"]),
    explore() {
      switch (this.lang) {
        case "en":
          return "Explore";
          break;
        case "fr":
          return "Go";
          break;
        case "es":
          return "Explorar";
          break;
        case "de":
          return "Ansehen";
          break;
        case "it":
          return "Entra";
          break;
        case "nl":
          return "Doorgaan";
          break;
        case "pt":
          return "Entrar";
          break;
        case "jp":
          return "開始";
          break;
      }
    },
    splashIntroText() {
      switch (this.lang) {
        case "en":
          return this.splashIntro.en;
          break;
        case "fr":
          return this.splashIntro.fr;
          break;
        case "es":
          return this.splashIntro.es;
          break;
        case "de":
          return this.splashIntro.de;
          break;
        case "it":
          return this.splashIntro.it;
          break;
        case "pt":
          return this.splashIntro.pt;
          break;
        case "nl":
          return this.splashIntro.nl;
          break;
        case "jp":
          return this.splashIntro.jp;
          break;
      }
    },
  },
  methods: {
    ...mapActions(["isSplashOpenAction", "languageAction"]),
  },
};
</script>

<style>
</style>